import { render, staticRenderFns } from "./QZSettings.vue?vue&type=template&id=ba9e87cc"
import script from "./QZSettings.vue?vue&type=script&lang=js"
export * from "./QZSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports